import { render, staticRenderFns } from "./ClueBestCard.vue?vue&type=template&id=640ef09d&scoped=true"
import script from "./ClueBestCard.vue?vue&type=script&lang=js"
export * from "./ClueBestCard.vue?vue&type=script&lang=js"
import style0 from "./ClueBestCard.vue?vue&type=style&index=0&id=640ef09d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ef09d",
  null
  
)

export default component.exports